import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetCompanyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.8077 5.84036C14.8076 6.40223 14.9734 6.95149 15.2841 7.4187C15.5948 7.8859 16.0364 8.25005 16.5531 8.4651C17.0699 8.68015 17.6384 8.73643 18.187 8.62683C18.7356 8.51724 19.2395 8.24668 19.6349 7.84938C20.0304 7.45208 20.2998 6.94588 20.4089 6.39481C20.518 5.84374 20.4619 5.27254 20.2479 4.75345C20.0338 4.23437 19.6713 3.79072 19.2062 3.4786C18.7412 3.16649 18.1944 2.99993 17.6351 3C16.8852 3 16.166 3.29925 15.6358 3.83192C15.1056 4.36459 14.8077 5.08705 14.8077 5.84036Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.658 26.6834L22.6861 26.6184C23.5322 24.6536 23.9258 22.8298 23.8893 21.0424C23.8277 18.1055 22.28 14.0469 19.6654 12.775C18.3116 12.1147 16.4921 12.0688 15.2578 12.9062C14.1291 13.674 13.3933 14.7232 13.2593 16.5079C12.9919 20.0622 15.73 24.2656 17.9275 27.1359L17.9708 27.1941C17.9708 27.1941 16.0813 32.8965 10 33.0366V37C17.122 36.8599 20.671 30.3462 20.671 30.3462L27.2166 36.8953L30 34.0991L22.658 26.6834ZM20.0002 23.2208C20.0002 23.2208 18.4755 21.6364 17.7559 19.8065C16.8357 17.4677 17.0215 16.4422 17.5237 16.2746C18.0043 16.1145 18.6467 16.8186 19.3534 18.9698C20.0181 20.9921 20.0002 23.2208 20.0002 23.2208Z",
		fill: "currentColor"
	})]
});
export default SvgAssetCompanyIcon;
